/**
 * nou: Custom PDP inventory-status custom element.
 *
 * Mirrors the theme's native product-inventory.js update mechanism so the low-stock /
 * out-of-stock line stays in sync with the selected variant on every path:
 *   - same-product size change      → variant:update on the closest section
 *   - combined-listing colour switch → event.detail.data.newProduct → adopt the new product id
 *
 * Loaded once on product pages (see sections/product-information.liquid) rather than inline in
 * the snippet, so the element is always defined — even on a colour whose buy buttons don't
 * render — and morph-inserted instances upgrade correctly.
 */
(function () {
  if (customElements.get('nou-inventory-status')) return;

  customElements.define(
    'nou-inventory-status',
    class extends HTMLElement {
      connectedCallback() {
        this._update = this._update.bind(this);
        // Match the theme's components: variant:update is dispatched on / bubbles to the section.
        this._section = this.closest('.shopify-section, dialog') || document;
        this._section.addEventListener('variant:update', this._update);
      }

      disconnectedCallback() {
        if (this._section) this._section.removeEventListener('variant:update', this._update);
      }

      _update(event) {
        var data = event && event.detail && event.detail.data;
        if (!data || !data.html) return;

        if (data.newProduct) {
          // Combined-listing colour switch — the product changed; adopt the new id.
          this.dataset.productId = data.newProduct.id;
        } else if (
          event.target &&
          event.target.dataset &&
          event.target.dataset.productId &&
          event.target.dataset.productId !== this.dataset.productId
        ) {
          // A different product's variant changed (e.g. a recommendation card) — ignore.
          return;
        }

        var fresh = data.html.querySelector('nou-inventory-status');
        if (!fresh) return;
        this.innerHTML = fresh.innerHTML;
      }
    }
  );
})();
